module.exports = __webpack_public_path__ + "static/img/consult4-1.6f12492d.png";